var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanknoteArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 28.5H6.33341C5.49356 28.5 4.68811 28.1664 4.09424 27.5725C3.50038 26.9786 3.16675 26.1732 3.16675 25.3333V12.6667C3.16675 11.8268 3.50038 11.0214 4.09424 10.4275C4.68811 9.83363 5.49356 9.5 6.33341 9.5H31.6667C32.5066 9.5 33.3121 9.83363 33.9059 10.4275C34.4998 11.0214 34.8334 11.8268 34.8334 12.6667V20.5833M25.3334 30.0833L30.0834 34.8333M30.0834 34.8333L34.8334 30.0833M30.0834 34.8333V25.3333M28.5001 19H28.5159M9.50008 19H9.51591M22.1667 19C22.1667 20.7489 20.749 22.1667 19.0001 22.1667C17.2512 22.1667 15.8334 20.7489 15.8334 19C15.8334 17.2511 17.2512 15.8333 19.0001 15.8333C20.749 15.8333 22.1667 17.2511 22.1667 19Z",
    stroke: "#070707",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknoteArrowDown);
export default __webpack_public_path__ + "static/media/banknote-arrow-down.0249e5adc2417959fa1f340c5e4a46e9.svg";
export { ForwardRef as ReactComponent };